import { X, Play, Plus, ThumbsUp } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const MovieModal = ({ movie, onClose }) => {
  if (!movie) return null;  
  
  const navigate = useNavigate();
  
  const handlePlayClick = (e) => {
    e.preventDefault();
    
    // En lugar de verificar autenticación aquí, simplemente navegamos a la ruta de la película
    // y dejamos que MoviePlayer.js maneje la verificación y muestre el mensaje adecuado
    navigate(`/movies/movie/${movie.id}`);
  };

  const imageUrl = movie.banner
    ? movie.banner
    : `https://image.tmdb.org/t/p/original${
        movie.backdrop_path || movie.poster
      }`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-70 sm:px-6">
      <div className="relative w-full max-w-lg overflow-hidden bg-black rounded-lg sm:max-w-2xl md:max-w-4xl">
        <button
          onClick={onClose}
          className="absolute z-10 p-2 bg-black rounded-full top-4 right-4 hover:bg-opacity-75"
        >
          <X className="w-6 h-6 text-white" />
        </button>

        <div className="relative h-[50vw] max-h-[350px] sm:max-h-[400px]">
          <img
            src={imageUrl}
            alt={movie.title}
            className="object-cover w-full h-full"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />

          <div className="absolute bottom-0 left-0 right-0 p-4 space-y-4 sm:p-6 md:p-8">
            <h2 className="text-2xl font-bold text-white sm:text-3xl md:text-4xl">
              {movie.title}
            </h2>

            <div className="flex space-x-3">
              <button 
                onClick={handlePlayClick}
                className="flex items-center px-4 py-2 text-sm font-semibold text-black bg-white rounded hover:bg-white/90 sm:text-base"
              >
                <Play className="w-4 h-4 mr-2 sm:h-5 sm:w-5" fill="black" />
                Reproducir
              </button>
              <button className="p-2 rounded-full bg-white/30 hover:bg-white/20">
                <Plus className="w-4 h-4 text-white sm:h-5 sm:w-5" />
              </button>
              <button className="p-2 rounded-full bg-white/30 hover:bg-white/20">
                <ThumbsUp className="w-4 h-4 text-white sm:h-5 sm:w-5" />
              </button>
            </div>
          </div>
        </div>

        {/* Movie information */}
        <div className="p-4 sm:p-6 md:p-8">
          <div className="space-y-4">
            {/* Metadata */}
            <div className="flex flex-wrap items-center space-x-3 text-xs sm:text-sm text-white/70">
              {movie.vote_average && (
                <span className="font-semibold text-green-500">
                  {Math.round(movie.vote_average * 10)}% coincidencia
                </span>
              )}
              {movie.release_date && (
                <span>{movie.release_date.split("-")[0]}</span>
              )}
              <span className="px-1 border">16+</span>
              {movie.runtime && <span>{movie.runtime} min</span>}
              <span className="px-1 text-xs border border-white/40">HD</span>
            </div>
<p className="text-gray-200 leading-relaxed font-bold">
  {movie.name}
</p>
            <p className="text-base text-white sm:text-lg">
              {movie.overview || movie.description}
            </p>

            {movie.genres && movie.genres.length > 0 && (
              <div className="text-xs sm:text-sm">
                <span className="text-white/50">Géneros: </span>
                <span className="text-white">
                  {movie.genres.map((genre) => genre.name).join(", ")}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieModal;
